import FileSaver from "file-saver"
import XLSX from "xlsx"

export function exports(xtable,name,fix){
    var xlsxParam = { raw: true } 
    if(fix){
        var wbs = XLSX.utils.table_to_book(xtable.removeChild(fix),xlsxParam)
        xtable.appendChild(fix);
    }else{
        var wbs = XLSX.utils.table_to_book(xtable,xlsxParam)
    }
    var wbout = XLSX.write(wbs, { bookType: 'xlsx', bookSST: true, type: 'array' })
    try {
    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), `${name}.xlsx`)
    } catch (e) { 
    if (typeof console !== 'undefined') console.log(e, wbout) 
    }
    return wbout
}
